<template>
  <lu-hbox lu-flex class='pageHeader' :class="{pageHeaderViewsTag: hasViewsTag} " lu-hcenter >

    <lu-hbox lu-flex lu-flex-wrap lu-vcenter class='pad-in-20'>
      <lu-item lu-flex lu-vcenter class='headerTitle' :class="resizeFont('title')">{{ title }}</lu-item>

      <slot name='beforeArea'/>

      <el-tooltip class="item lu-click" :effect="styleTooltip" :content="$t('List')" placement="top" v-if='hasList' >
        <!-- <svg-icon icon-class="list" @click.stop='onBack' /> -->
        <lu-item class='headerIcon el-icon-s-fold' style='margin-right: 20px;' @click.stop='onBack' />
      </el-tooltip>
      <el-tooltip class="item lu-click" :effect="styleTooltip" :content="$t('Refresh')" placement="top"  v-if='hasReload'>
        <!-- <svg-icon  icon-class="example" @click='onReload' /> -->
        <lu-item class='headerIcon el-icon-refresh' style='margin-right: 20px;' @click.stop='onReload' />
      </el-tooltip>

      <el-tooltip class="item" :effect="styleTooltip" :content="$t('Previous')" placement="top" v-if='hasPrev !== null '>
        <lu-item class='headerIcon el-icon-caret-left' style='margin-right: 20px;' :class='hasPrev ? "lu-click" : "disabled"' @click.stop='onPrev'></lu-item>
      </el-tooltip>
      <el-tooltip class="item" :effect="styleTooltip" :content="$t('Next')" placement="top" v-if='hasNext !== null'>
        <lu-item class='headerIcon el-icon-caret-right' :class='hasNext ? "lu-click" : "disabled"' @click.stop='onNext'></lu-item>
      </el-tooltip>
      <el-tooltip class="item" :effect="styleTooltip" :content="$t('Settings')" placement="top" v-if='hasSettings'>
        <lu-item class='headerIcon el-icon-s-tools' :class='hasSettings ? "lu-click" : "disabled"' @click.stop='onSettings'></lu-item>
      </el-tooltip>
      <el-tooltip class="item" :effect="styleTooltip" :content="$t('Close')" placement="top" v-if='hasClose'>
        <lu-item class='headerIcon el-icon-close text-red' :class='hasClose ? "lu-click" : "disabled"' @click.stop='onClose'></lu-item>
      </el-tooltip>

      <slot name='extraArea'/>

      <transition name='fold'>
        <lu-vbox lu-flex v-if='message'>
          <lu-item lu-vcenter :class='isSuccess ? "headerSuccess" : "headerError"'>{{ message }} </lu-item>
        </lu-vbox>
      </transition>

    </lu-hbox>

  </lu-hbox>
</template>

<script>
import { LuHbox, LuItem } from 'lusis-ui'
import { mapState, mapGetters } from 'vuex'
import utilsMixin from '@/mixins/utils'

export default {
  name: 'PageHeader',
  mixins: [ utilsMixin ],
  props: {
    'title': { default: '' },
    'message': { default: '' },
    'isSuccess': { default: false },
    'logo': { default: false },
    'hasList': { default: false },
    'hasReload': { default: false },
    'hasPrev': { default: null },
    'hasNext': { default: null },
    'hasSettings': { default: false },
    'hasClose': { default: false },
    'extraBtn': { default: false }
  },
  components: { LuItem, LuHbox },
  computed: {
    ...mapGetters( ['size', 'theme'] ),
    ...mapState({ hasViewsTag: state => state.settings.tagsView }),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    }
  },
  methods: {
    onPrev () {
      if (this.hasPrev) this.$emit('prev')
    },
    onNext () {
      if (this.hasNext) this.$emit('next')
    },
    onBack () {
      this.$emit('back')
    },
    onReload () {
      this.$emit('reload')
    },
    onSettings () {
      if (this.hasSettings) this.$emit('settingsToggle')
    },
    onClose () {
      if (this.hasClose) this.$emit('close')
    }
  },
  data () {
    return {
    }
  }
}
</script>
<style scoped>
.disabled {
  color: #999;
}

</style>
